import { MDTApp } from './bootAction.js';
import { unreadNotifications } from '../services/notifications.js';
import { updateNotificationCount } from '../reducers/notificationReducer.js';

export const getNotificationCount = () => {
    return (dispatch, getState) => {
        let appId = MDTApp.getSetting('appid');
        let customerId = getState().meDetails.customerId;

        const data = {
            bu: MDTSetting.pathVars.buid,
            history: false
        };

        // Customer filtering
        if (customerId) {
            data.customer = customerId;
        }

        // Application filtering
        if (appId) {
            data.app = appId;
            data.allAppNotification = false;
        } else {
            data.allAppNotification = true;
        }

        return unreadNotifications(data).then(data => {
            data && dispatch(updateNotificationCount(data));
        }).catch(error => {
            throw (error);
        });
    }
}
